<template>
  <div class="selectplan">
    <h1 class="txt-center" style="font-size: 28px; margin-bottom: 18px;">
        Escolha seu novo Plano!
    </h1>
    <div class="grid margin-top-l row">
        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center middle">
              <h2>Essencial</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Até R$ 20.000 / mês em vendas</li>
                  <li>ou 150 vendas / mês</li>
                  <li>Até 1.000 leads / mês</li>
                  <li>1 conta de anúncio</li>
                  <li>1 dashboard</li>
                  <li>15 dias de dados</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 97,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[0])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l no-mobile">
          <div class="box-title flex center middle">
              <h2>Profissional</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Até R$ 100.000 / mês em vendas</li>
                  <li>Até 5.000 leads / mês</li>
                  <li>5 conta de anúncio</li>
                  <li>3 dashboard</li>
                  <li>1 Whatsapp Trackeado</li>
                  <li>1 Domínio Trackeado</li>
                  <li>90 dias de dados</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 147,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[1])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center">
              <h2>Completo</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Até R$ 500.000 / mês em vendas</li>
                  <li>Até 25.000 leads / mês</li>
                  <li>20 conta de anúncio</li>
                  <li>6 dashboard</li>
                  <li>2 Whatsapp Trackeado</li>
                  <li>2 Domínio Trackeado</li>
                  <li>12 meses de dados</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 297,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[2])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center middle">
              <h2>Ilimitado</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Até R$ 5.000.000 / mês em vendas</li>
                  <li>Até 100.000 leads / mês</li>
                  <li>50 conta de anúncio</li>
                  <li>10 dashboard</li>
                  <li>5 Whatsapp Trackeado</li>
                  <li>10 Domínio Trackeado</li>
                  <li>Sem limite de dados</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 497,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[3])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center middle">
              <h2>Para Agência</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content">
                <ul class="margin-top-m">
                  <li>Para até 10 clientes ou seja Você só paga R$ 59,70 por cliente (Profissional)</li>
                  <li>Uma conta individual para cada Cliente</li>
                  <li>Todos os recursos do plano Profissional!</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 597,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[4])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

      </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "subscription",
  components: {},
  props: ["slug"],
  data() {
    return {
      loading: false,
      urlPlan: [
        "https://pay.kiwify.com.br/zc8ELdY", // essencial
        "https://pay.kiwify.com.br/k0MlC8p", // profissional
        "https://pay.kiwify.com.br/mJgDu3J", // completo
        "https://pay.kiwify.com.br/8xrQVDT", // ilimitado
        "https://pay.kiwify.com.br/Xd2uLpi" // agencia
      ],
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    adjustUrl(url) {
      if (!this.account) {
        return
      }
      if (this.account.afiliate_kiwify_code) {
        return `${url}?name=${this.account.name}&email=${this.account.email}&phone=${this.account.phone}&utm_source=ACC${this.account.id}&afid=${this.account.afiliate_kiwify_code}`
      }
      return `${url}?name=${this.account.name}&email=${this.account.email}&phone=${this.account.phone}&utm_source=ACC${this.account.id}`
    },
    updateAccount(url) {
        var urlf = this.adjustUrl(url)
        document.location.href = urlf
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  min-width: 300px;
  min-height: 130px;
  margin-top: 16px;
  margin-left: 0px !important;
  margin-right: 20px;

  a {
    width: 100%;
    height: 100%;

    &:hover {
      color:#fff;
    }
  }
}

.disabled-box {
  background: #e8e8e8;
  > a {
    cursor: none;
  }
}

.tag {
  background: var(--primary);
  color: #fff;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 10px;
  font-weight: 600;
}

.destaque {
  color: var(--terciary) !important;
  font-size: 32px;
}

.selectplan {

  .de-price {
    color: #666;
  }

  .promo {
    position: absolute;
    top: 20px;
    padding: 8px 16px;
    background: yellow;
    color: #000;
    border-radius: 4px;
    font-weight: 800;
  }

  .box {
    .box-content {
      position: relative;
      .content {
        min-height: 165px;
      }
      ul {
        margin-left: 14px;
        li {
          padding: 4px;
        }
      }

      .action {
        border-top: 1px solid #00000022;
      }
    }
    .box-title {
      padding: 4px 15px;
      h2 {
        font-size: 28px;
        font-weight: 800;
      }
    }
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-content: center;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
</style>
